// extracted by mini-css-extract-plugin
export default {"ContentHeader":"styles_ContentHeader__jtLb9","ContentText":"styles_ContentText__Sh8lM"};